<template>
  <img :src="userProfilePictureUrl" alt="Profile Picture" :width="this.size" :height="this.size" />
</template>
<script>
import { mapState } from 'vuex'
import _ from 'lodash'
export default {
  name: 'ProfilePicture',
  props: {
    userProfilePicture: {
      type: String,
      required: false,
    },
    defaultPictureUrl: {
      type: String,
      required: false,
      default: 'https://avvay-aws-production.imgix.net/site-assets/pro-default-avatar-lg.png',
    },
    isPro: {
      type: Boolean,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(['env']),
    userProfilePictureUrl: function() {
      if(!_.isEmpty(this.userProfilePicture)){
        // This is the ratio that was used before this was a component, when the size was 128 and had a padding of 6:
        // 0.046875 = 6 / 128
        const baseProfileUrl = `${this.env.userMediaUrl}${this.userProfilePicture}`;

        const padding = Math.round(0.046875 * this.size);
        const mark = this.isPro ? 'aHR0cHM6Ly9zMy5hbWF6b25hd3MuY29tL2VzLm1ha2VzcGFjLmNvcmUuYXdzLnByb2R1Y3Rpb24ucHVibGljL3NpdGUtYXNzZXRzL3Byb21hcmstbGcucG5n&markscale=25' : ''

        return `${baseProfileUrl}?${this.genericParams}&markpad=${padding}&mark64=${mark}`;
      } else {
        // return `https://avvay-aws-production.imgix.net/site-assets/pro-default-avatar-lg.png?${this.genericParams}`;
        return `${this.defaultPictureUrl}?${this.genericParams}`;
      }
    },
    genericParams: function() {
      // Assume they're on retina display
      const dpr = 2;
      return `w=${this.size}&h=${this.size}&crop=fit&mask=ellipse&faceindex=1&fit=facearea&facepad=2&fm=png&dpr=${dpr}`;
    },
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/user/profile/components/ProfilePicture.vue